module.exports = __webpack_public_path__ + "static/media/wsymbol_0017_cloudy_with_light_rain_big_s1.38a6af2d.png";